import { z } from 'zod';

export type ClassificationCoordinate = z.infer<typeof ClassificationCoordinate>;
export type ClassificationLocation = z.infer<typeof ClassificationLocation>;

export const ClassificationCoordinate = z.object({
    imageWidthPercentage: z.number(),
    imageHeightPercentage: z.number(),
});

export const ClassificationLocation = z.object({
    upperLeft: ClassificationCoordinate,
    lowerRight: ClassificationCoordinate,
});
